import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable }  from 'rxjs';

export interface HhsgSharedCanComponentDeactivate {
    canDeactivate: (
        component: HhsgSharedCanComponentDeactivate, 
        route: ActivatedRouteSnapshot, 
        state: RouterStateSnapshot, 
        nextState: RouterStateSnapshot) => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
    providedIn: 'root',
})
export class HhsgSharedCanDeactivateGuard implements CanDeactivate<HhsgSharedCanComponentDeactivate> {
    canDeactivate(component: HhsgSharedCanComponentDeactivate, route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState: RouterStateSnapshot) {
        var dirtyFormOverrideUrls = ["/inactive", "/concurrent","/idlelogout"];

        if(dirtyFormOverrideUrls.indexOf(nextState.url) > -1){
            return true;
        }

        return component.canDeactivate ? component.canDeactivate(component, route, state, nextState) : true;
    }
}